<template>
    <b-card no-body class="inner-layout" :style="showScrollbar ? 'height: auto' : ''">
        <ul class="nav nav-tabs tab-deactive" style="background-color: #eff3f6; border-bottom-color: transparent !important;">
            <li v-for="tag, i in tags" :key="i" class="nav-item" style="cursor: pointer;">
                <div @click="routeTo(tag)" :class="{'nav-link': true, 'active': tag.active}">{{ tag.name }}</div>
            </li>
        </ul>
        <b-card-body class="border border-top-0" :style="showScrollbar ? 'min-height: auto !important' : ''">
            <router-view/>
        </b-card-body>
    </b-card>
</template>

<script>
import _ from 'lodash';
export default {
    name: 'Master',
    props: {
        showScrollbar: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            activeTagIndex: 0,
            tags: [
                {
                    name: this.$t('emissionLibraryManagement'),
                    path: 'emission-library',
                    active: false
                },
                {
                    name: this.$t('locationsManagement'),
                    path: 'locations',
                    active: false
                },
                {
                    name: this.$t('tags'),
                    path: 'tags',
                    active: false
                }
            ]
        };
    },

    methods: {
        routeTo(tag) {
            this.tags.forEach(function(tag) {
                tag.active = false;
            });
            tag.active = true;

            this.$router.push({name: tag.path});
            return Promise.resolve();
        }
    },
    created() {
        this.activeTagIndex = _.indexOf(this.tags, _.find(this.tags, o => o.path == this.route.name));
        this.activeTagIndex = this.activeTagIndex < 0 ? 0 : this.activeTagIndex;
        this.routeTo(this.tags[this.activeTagIndex]);
    }
};
</script>

<style scoped>
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "tags": "Etiket Yönetimi",
            "locationsManagement": "Lokasyon ve Sektör Yönetimi",
            "emissionLibraryManagement": "Emisyon Kütüphanesi Yönetimi"
        },
        "en": {
            "tags": "Tag Management",
            "locationsManagement": "Location & Sector Management",
            "emissionLibraryManagement": "Emission Library Management"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/Master.vue